import { createAction, props } from '@ngrx/store';

import { RestInspectionsModel } from '@main-application/inspections/models/rest-inspections-model.interface';

export const loadCalendarInspections = createAction(
  '[Calendar] loadCalendarInspections',
  props<{
    startDate?: Date;
    endDate?: Date;
    secondStartDate?: Date;
    secondEndDate?: Date;
  }>()
);
export const loadCalendarInspectionsSuccess = createAction(
  '[Boards] loadCalendarInspectionsSuccess',
  props<{ inspections: RestInspectionsModel[] }>()
);
export const loadCalendarInspectionsFailed = createAction('[Boards] loadBoardListFailed');

export const updateCalendarInspection = createAction(
  '[Calendar] Update Calendar Inspection',
  props<{ inspection: RestInspectionsModel }>()
);
